unit Unit3;

interface

uses
  SysUtils, Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.Buttons, WEBLib.StdCtrls,
  WEBLib.ExtCtrls, WEBLib.REST,
  BaseResponse, Client, LoginRequest, LoginResponse, TermListGetRequest, TermListGetResponse;

type
  TForm3 = class(TForm)
    WebImageControl1: TImageControl;
    WebButton1: TButton;
    WebSpeedButton1: TSpeedButton;
    WebBitBtn1: TBitBtn;
    WebRESTClient1: TRESTClient;
    WebHttpRequest1: THttpRequest;
    WebButton2: TButton;
    WebListBox1: TListBox;
    procedure WebBitBtn1MouseEnter(Sender: TObject);
    procedure WebBitBtn1MouseLeave(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
    procedure WebHttpRequest1Response(Sender: TObject; AResponse: string);
    procedure WebHttpRequest1RequestResponse(Sender: TObject;
      ARequest: TJSXMLHttpRequestRecord; AResponse: string);
    procedure WebHttpRequest1Timeout(Sender: TObject);
    procedure WebHttpRequest1Error(Sender: TObject;
      ARequest: TJSXMLHttpRequestRecord; Event: TJSEventRecord;
      var Handled: Boolean);
    procedure WebButton2Click(Sender: TObject);
    procedure RestClientOnResult(BaseResponse: TBaseResponse; const Boolean_Error: Boolean);
  private
    { Private declarations }
  protected
    procedure LoadDFMValues; override;
  public
    { Public declarations }
  end;

var
  Form3: TForm3;
  RestClient: TClient;

implementation


procedure TForm3.WebBitBtn1MouseEnter(Sender: TObject);
begin
  WebBitBtn1.Color := clRed;
end;

procedure TForm3.WebBitBtn1MouseLeave(Sender: TObject);
begin
  WebBitBtn1.Color := clYellow;
end;

procedure TForm3.WebButton1Click(Sender: TObject);
begin
  {ShowMessage(window.atob('ERBASOFT:Es637485!'));}

{  WebHttpRequest1.Headers.Add('Access-Control-Allow-Origin=*');
  WebHttpRequest1.Headers.Add('Access-Control-Allow-Headers=*');}
  WebHttpRequest1.Headers.Add('Content-Type=application/json');
  WebHttpRequest1.Headers.Add('Authorization=Basic RVJCQVNPRlQ6RXM2Mzc0ODUh');

  {WebHttpRequest1.Headers.Add('Basic ' + window.atob('ERBASOFT:Es637485!'));
  WebHttpRequest1.Headers.Add('Content-Type:application/json');}

  WebHttpRequest1.Command := httpPOST;

  WebHttpRequest1.Execute;
  WebButton1.Enabled := false;
end;

procedure TForm3.WebButton2Click(Sender: TObject);
var TermListGetResponse: TTermListGetResponse;
    LoginRequest: TLoginRequest;
    TermListGetRequest: TTermListGetRequest;
    LoginResponse: TLoginResponse;
begin
  RestClient := TClient.Create('ERBASOFT', 'Es637485!');
  RestClient.OnResult := RestClientOnResult;

  LoginRequest := TLoginRequest.Create('', 'PP', 'ERBASOFT');

  RestClient.Call('/login/login', LoginRequest, True);

  LoginRequest.Free;

  //TermListGetRequest := TTermListGetRequest.Create('Debug', 'nl', 0);

  //RestClient.Call('/term/listget', TermListGetRequest, True);

  //TermListGetRequest.Free;
end;

procedure TForm3.WebHttpRequest1Error(Sender: TObject;
  ARequest: TJSXMLHttpRequestRecord; Event: TJSEventRecord;
  var Handled: Boolean);
begin
  ShowMessage('Error');
  WebButton1.Enabled := True;
end;

procedure TForm3.WebHttpRequest1RequestResponse(Sender: TObject;
  ARequest: TJSXMLHttpRequestRecord; AResponse: string);
begin
  ShowMessage('Start!');
end;

procedure TForm3.WebHttpRequest1Response(Sender: TObject; AResponse: string);
begin
  WebListBox1.Items.Add(AResponse);
  WebButton1.Enabled := True;
end;

procedure TForm3.WebHttpRequest1Timeout(Sender: TObject);
begin
  ShowMessage('TimeOut');
end;

procedure TForm3.RestClientOnResult(BaseResponse: TBaseResponse; const Boolean_Error: Boolean);
var TermListGetResponse: TTermListGetResponse;
    LoginResponse: TLoginResponse;
begin
  ShowMessage('Return');
  //TermListGetResponse := BaseResponse as TTermListGetResponse;

  //ShowMessage(TermListGetResponse.Language);
  //ShowMessage(IntToStr(Length(TermListGetResponse.TermList.TermArray)));

  //TermListGetResponse.Free;
  if not Boolean_Error then
  begin
    LoginResponse := BaseResponse as TLoginResponse;

    ShowMessage(LoginResponse.Login.LoginKey);
  end
  else
    ShowMessage('Error');

    LoginResponse.Free;

    RestClient.Free;
end;

procedure TForm3.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebImageControl1 := TImageControl.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebBitBtn1 := TBitBtn.Create(Self);
  WebButton2 := TButton.Create(Self);
  WebListBox1 := TListBox.Create(Self);
  WebRESTClient1 := TRESTClient.Create(Self);
  WebHttpRequest1 := THttpRequest.Create(Self);

  WebImageControl1.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebBitBtn1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WebListBox1.BeforeLoadDFMValues;
  WebRESTClient1.BeforeLoadDFMValues;
  WebHttpRequest1.BeforeLoadDFMValues;
  try
    Name := 'Form3';
    Left := 0;
    Top := 0;
    Width := 640;
    Height := 480;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Arial';
    Font.Style := [];
    TabOrder := 1;
    WebImageControl1.SetParentComponent(Self);
    WebImageControl1.Name := 'WebImageControl1';
    WebImageControl1.Left := 72;
    WebImageControl1.Top := 72;
    WebImageControl1.Width := 104;
    WebImageControl1.Height := 86;
    WebImageControl1.Margins.Left := 30;
    WebImageControl1.Margins.Top := 30;
    WebImageControl1.Margins.Right := 30;
    WebImageControl1.Margins.Bottom := 30;
    WebImageControl1.AutoSize := True;
    WebImageControl1.Picture.LoadFromFile('Unit3.WebImageControl1.Picture.bmp');
    WebButton1.SetParentComponent(Self);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 152;
    WebButton1.Top := 272;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'WebButton1';
    WebButton1.ChildOrder := 1;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebSpeedButton1.SetParentComponent(Self);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 432;
    WebSpeedButton1.Top := 120;
    WebSpeedButton1.Width := 153;
    WebSpeedButton1.Height := 177;
    WebSpeedButton1.Caption := 'WebSpeedButton1';
    WebSpeedButton1.Glyph.LoadFromFile('Unit3.WebSpeedButton1.Glyph.bmp');
    WebSpeedButton1.Layout := blGlyphTop;
    WebBitBtn1.SetParentComponent(Self);
    WebBitBtn1.Name := 'WebBitBtn1';
    WebBitBtn1.Left := 128;
    WebBitBtn1.Top := 344;
    WebBitBtn1.Width := 153;
    WebBitBtn1.Height := 128;
    WebBitBtn1.Hint := 'Dit is een gele button.';
    WebBitBtn1.Caption := 'WebBitBtn1';
    WebBitBtn1.Color := clYellow;
    WebBitBtn1.Glyph.LoadFromFile('Unit3.WebBitBtn1.Glyph.bmp');
    WebBitBtn1.ShowHint := True;
    WebBitBtn1.TabOrder := 2;
    SetEvent(WebBitBtn1, Self, 'OnMouseLeave', 'WebBitBtn1MouseLeave');
    SetEvent(WebBitBtn1, Self, 'OnMouseEnter', 'WebBitBtn1MouseEnter');
    WebButton2.SetParentComponent(Self);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 64;
    WebButton2.Top := 224;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'WebButton2';
    WebButton2.ChildOrder := 5;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    WebListBox1.SetParentComponent(Self);
    WebListBox1.Name := 'WebListBox1';
    WebListBox1.Left := 304;
    WebListBox1.Top := 303;
    WebListBox1.Width := 233;
    WebListBox1.Height := 162;
    WebListBox1.ItemHeight := 14;
    WebListBox1.ItemIndex := -1;
    WebRESTClient1.SetParentComponent(Self);
    WebRESTClient1.Name := 'WebRESTClient1';
    WebRESTClient1.Left := 288;
    WebRESTClient1.Top := 80;
    WebHttpRequest1.SetParentComponent(Self);
    WebHttpRequest1.Name := 'WebHttpRequest1';
    WebHttpRequest1.Command := httpPOST;
    WebHttpRequest1.PostData := '{"loginKey":"Debug","searchString":""}';
    WebHttpRequest1.URL := 'http://81.169.166.63:9092/erbasoft/net/listget';
    SetEvent(WebHttpRequest1, Self, 'OnError', 'WebHttpRequest1Error');
    SetEvent(WebHttpRequest1, Self, 'OnResponse', 'WebHttpRequest1Response');
    SetEvent(WebHttpRequest1, Self, 'OnRequestResponse', 'WebHttpRequest1RequestResponse');
    SetEvent(WebHttpRequest1, Self, 'OnTimeout', 'WebHttpRequest1Timeout');
    WebHttpRequest1.Left := 288;
    WebHttpRequest1.Top := 184;
  finally
    WebImageControl1.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebBitBtn1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WebListBox1.AfterLoadDFMValues;
    WebRESTClient1.AfterLoadDFMValues;
    WebHttpRequest1.AfterLoadDFMValues;
  end;
end;

end.
